<template>
  <div>
    <v-container fill-height fluid>
    <v-row>
      <v-spacer></v-spacer>
      <v-btn
        v-if="can('create schools')"
        @click="showSchoolCodeModal(0)"
        color="primary"
        dark
        class="mb-2"
      >{{ $t("NEW") }}
      </v-btn>
    </v-row>
    </v-container>
    <v-data-table
      :headers="headers"
      :items="items"
      :server-items-length="totalItems"
      :no-data-text="$t('NO_DATA')"
      :no-results-text="$t('NO_DATA')"
      hide-default-footer
      :options.sync="pagination"
      :loading="loading"
      class="elevation-1"
    >

      <template v-slot:item.updated_at="{ item }">
            {{ item.updated_at | timeFormat }}
      </template>
      <template v-slot:item.actions="{ item }">
            <v-layout row wrap>
              <v-flex class="text-no-wrap">
                <v-btn
                  icon
                  color="blue"
                  v-if="can('edit schools')"
                  @click="showSchoolCodeModal(item.id)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn
                  v-if="can('delete schools')"
                  icon
                  color="red"
                  @click="deleteSchoolCode(item.id)"
                >
                  <v-icon>cancel</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
      </template>
    </v-data-table>
    <Paginator
      :total-items="totalItems"
      :page.sync="pagination.page"
      :items-per-page.sync="pagination.itemsPerPage"
      @change="fetchSchoolCodes"
    />
  </div>
</template>

<script>
  import { mapActions } from 'vuex';

  import { schoolsCodesService } from '../../../utils/services/schoolsCodes.service';
  import SchoolCodeModal from '../../modals/Schools/SchoolCodeModal';
  import Paginator from '../../shared/Paginator';

  export default {
    name: 'SchoolCodesDetails',
    components: { Paginator },
    props: {
      school: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        loading: false,
        items: [],
        totalItems: 0,
        pagination: {
          page: 1,
          itemsPerPage: 10,
          sortDesc: [false],
          sortBy: ['name'],
        },
        headers: [
          { text: this.$t('fields.code'), value: 'name' },
          { text: this.$t('fields.note'), value: 'note' },
          { text: this.$t('fields.actions'), value: 'actions', sortable: false, align: 'center' },
        ],
      };
    },
    computed: {
      requestFilters() {
        const filters = {};
        if (this.pagination.sortBy.length === 1 && this.pagination.sortDesc.length === 1) {
          const { sortBy, sortDesc } = this.pagination;
          filters.sortBy = sortBy;
          filters.sortDesc = sortDesc;
        }
        return filters;
      },
    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('modal', ['showModal', 'hideModal']),
      ...mapActions('alert', ['showToast']),

      async showSchoolCodeModal(id) {
        this.showModal({
          component: SchoolCodeModal,
            data: {
              stored: {
                id,
                school_id: this.school.id,
              },
          },
          options: {
            title: this.$t('SCHOOL_CODE'),
            onSave: (
              form,
              error,
            ) => schoolsCodesService.save(form)
            .then(() => {
              this.fetchSchoolCodes(this.pagination.page);
              this.hideModal({});
              this.showToast({ type: 'success', message: this.$t('SAVED') });
            })
            .catch(error => {
              this.handleError(error, this.errors);
            })
            .finally(() => {
              this.fetchSchoolCodes(this.pagination.page);
            }),
          },
        });
      },

      async fetchSchoolCodes(forcePage) {
        this.loading = true;
        const { page, itemsPerPage } = this.pagination;
        return schoolsCodesService.index(this.school.id, {
          page: page || forcePage || 1,
          itemsPerPage,
          filters: this.requestFilters,
        })
        .then((response) => {
            this.items = response.data.data;
            this.totalItems = response.data.meta.total;
            this.pagination = this.getPagination(
              response.data.meta,
              { oldPagination: this.pagination, forcePage },
            );
        })
        .catch(error => {
          this.handleError(error, this.errors);
        })
        .finally(() => {
          this.loading = false;
        });
      },

      async deleteSchoolCode(id) {
          this.showConfirm({
            onConfirm: () => {
              this.loading = true;
              return schoolsCodesService.remove(this.school.id, id)
              .then(() => {
                this.showToast({ type: 'success', message: this.$t('DELETED') });
                this.fetchSchoolCodes(this.pagination.page);
              })
              .catch(error => {
                this.handleError(error, this.errors);
              })
              .finally(() => {
                this.loading = false;
              });
            },
          });
      },
    },
    async created() {
      await this.fetchSchoolCodes();
    },
  };
</script>
